import React from "react";
import { Link } from "react-router-dom";
import { IMAGES } from "../lib/site";

const STEPS = [
  { n: "01", t: "Join the Waitlist", d: "Reserve your seat and become part of a founding community that shapes the future of Crowned Essence." },
  { n: "02", t: "Receive a Curated Box", d: "Each month, an editor-selected collection of premium Black-owned essentials arrives — beautifully packaged, ready to unbox." },
  { n: "03", t: "Discover Your New Favorites", d: "Fall in love with new brands, elevate your daily routine, and share the story of Black-owned excellence." },
];

export default function HowItWorks() {
  return (
    <div data-testid="how-it-works-page" className="pt-32">
      <section className="max-w-[1440px] mx-auto px-6 md:px-12 py-16 md:py-24 text-center">
        <div className="text-[11px] uppercase tracking-luxe text-gold mb-6">The Routine</div>
        <h1 className="font-serif text-5xl md:text-7xl leading-[0.95] max-w-3xl mx-auto">How Crowned<br/><span className="italic">Essence works.</span></h1>
        <p className="mt-8 max-w-xl mx-auto text-matte/70 text-lg font-light">Three intentional steps to a monthly routine worth anticipating.</p>
      </section>

      <section className="py-16 md:py-24 bg-cream">
        <div className="max-w-[1440px] mx-auto px-6 md:px-12 space-y-24 md:space-y-32">
          {STEPS.map((s, i) => (
            <div key={s.n} data-testid={`hiw-step-${s.n}`} className={`grid md:grid-cols-2 gap-12 md:gap-24 items-center ${i % 2 ? "md:flex-row-reverse" : ""}`}>
              <div className={i % 2 ? "md:order-2" : ""}>
                <div className="font-serif italic text-gold text-8xl md:text-9xl leading-none">{s.n}</div>
                <div className="gold-divider mt-6 mb-6" />
                <h2 className="font-serif text-4xl md:text-5xl">{s.t}</h2>
                <p className="mt-5 text-matte/70 leading-relaxed text-lg font-light">{s.d}</p>
              </div>
              <div className={`relative aspect-[4/5] overflow-hidden ${i % 2 ? "md:order-1" : ""}`}>
                <img src={i === 0 ? IMAGES.hero : i === 1 ? IMAGES.products : IMAGES.selfcare} alt={s.t} className="absolute inset-0 w-full h-full object-cover" />
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="py-24 md:py-32 text-center bg-ivory">
        <div className="max-w-3xl mx-auto px-6">
          <h2 className="font-serif text-4xl md:text-6xl leading-[1.05]">Your routine begins <span className="italic">here.</span></h2>
          <div className="mt-10">
            <Link data-testid="hiw-cta-waitlist" to="/waitlist" className="px-10 py-4 bg-matte text-gold border border-gold/40 text-[11px] uppercase tracking-luxe-sm hover:bg-black transition-colors">Join the Waitlist</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
